import api from '@/api'
import { RoleGroup } from '@/modules/@appbase/api/role'

export default {
    /**
     * 현재 로그인 되어 있는 사용자의 회사에 설정된 모든 웹파트 목록을 조회합니다.
     * @returns {Promise<webpart.Webpart[]>} 웹파트 목록
     */
    get(company:string): Promise<webpartv3.Webpart[]> {
        return api
            .get<webpartv3.Webpart[]>({
                url: `/Webpart/WebpartData/api/getlist?comCode=${company}`,
            })
            .then((webparts) =>
                webparts.map((x) => ({ ...x, roles: x.roles || [] }))
            )
    },

    /**
     * 현재 로그인 되어 있는 사용자에게 권한이 부여된 웹파트 목록만을 조회합니다.
     * @returns {Promise<webpart.Webpart[]>} 웹파트 목록
     */
    getPrivilegeList(): Promise<webpartv3.Webpart[]> {
        return api
            .get<webpartv3.Webpart[]>({
                url: '/Webpart/WebpartData/api/privileged',
            })
            .then((webparts) =>
                webparts.map((x) => ({ ...x, roles: x.roles || [] }))
            )
    },
    
    getRoles(id: string): Promise<RoleGroup[]> {
        return api.get({
            url: `/Webpart/WebpartData/api/roles?id=${id}`,
        })
    },

    /**
     * 웹파트를 저장합니다.
     * @param webpart 저장할 웹파트 데이터
     */
    save(webpart: webpartv3.Webpart): Promise<webpartv3.Webpart> {
        return api.post({
            url: '/Webpart/WebpartData/api/create',
            data: webpart,
        })
    },

    /**
     * 지정된 아이디를 가지는 웹파트를 삭제합니다.
     * @param {number} id 삭제할 웹파트 아이디
     */
    delete(id: string): Promise<boolean> {
        return api.delete<boolean>({
            url: `/Webpart/WebpartData/api/delete?id=${id}`,
        })
    },
}
